export default {
  "content": "<path d=\"M2.75 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M4.25 4.5v.75A.75.75 0 013.5 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.75M2.75 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5h-.75a.75.75 0 00-.75.75v.75m0 0H4.25m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003.5 15h-.75m12.75-4.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18.5V10.5zm-12 0h.008v.008H6.5V10.5z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "25",
    "height": "24",
    "viewBox": "0 0 25 24",
    "fill": "none"
  }
};